import { Button, Modal } from '@sequencehq/core-components'
import {
  MinimumEditorMode,
  MinimumEditorRootProps
} from 'modules/Cube/view/common/drawers/minimumEditor/drawer/minimumEditor.types'
import { MinimumDomainInterface } from 'modules/Cube/view/common/drawers/minimumEditor/drawer/minimumEditor.domain'
import { useMinimumEditorRoot } from 'modules/Cube/view/common/drawers/minimumEditor/drawer/content/useMinimumEditorRoot'
import { MinimumEditorDomainProvider } from 'modules/Cube/view/common/drawers/minimumEditor/drawer/minimumEditor.domain.context'
import { FC } from 'react'
import { MinimumEditorForm } from './MinimumEditorForm/MinimumEditorForm'
import { match } from 'ts-pattern'

const getDrawerTitle = (mode: MinimumEditorRootProps['mode']) => {
  return match(mode)
    .with(MinimumEditorMode.CREATE, () => 'Add minimum')
    .with(MinimumEditorMode.VIEW, () => 'View minimum')
    .with(MinimumEditorMode.EDIT, () => 'Edit minimum')
    .exhaustive()
}

const getSaveText = (mode: MinimumEditorRootProps['mode']) => {
  return match(mode)
    .with(MinimumEditorMode.CREATE, () => 'Add minimum')
    .with(MinimumEditorMode.VIEW, () => 'Update minimum')
    .with(MinimumEditorMode.EDIT, () => 'Update minimum')
    .exhaustive()
}

const MinimumEditorDrawer = (props: {
  onClose: () => void
  domain: MinimumDomainInterface
}) => {
  return (
    <Modal variant="drawer" isOpen onClose={props.onClose}>
      <Modal.Header onClose={props.onClose} showCloseButton>
        {getDrawerTitle(props.domain.queries.editor.mode)}
      </Modal.Header>
      <Modal.Content>
        <MinimumEditorForm />
      </Modal.Content>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => props.domain.mutators.save()}
          data-testid="minimumEditor.submit"
          disabled={!props.domain.queries.editor.canSave}
        >
          {getSaveText(props.domain.queries.editor.mode)}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export const MinimumsEditorRoot: FC<MinimumEditorRootProps> = props => {
  const { domain } = useMinimumEditorRoot(props)

  return (
    <MinimumEditorDomainProvider value={domain}>
      <MinimumEditorDrawer onClose={props.onClose} domain={domain} />
    </MinimumEditorDomainProvider>
  )
}
